import { createSelector } from 'reselect';
import requestStatusType from '../../constants/requestStatusTypes';
import { fetchFavoriteAssets } from '../api/favoritesApi';
const {
  UNINITIALIZED,
  PENDING,
  SUCCEEDED,
  FAILED
} = requestStatusType;
export const favoriteAssetsNamespace = 'favoriteAssets';

// Action types
const FETCH_FAVORITE_ASSETS_PENDING = 'FETCH_FAVORITE_ASSETS_PENDING';
const FETCH_FAVORITE_ASSETS_SUCCEEDED = 'FETCH_FAVORITE_ASSETS_SUCCEEDED';
const FETCH_FAVORITE_ASSETS_FAILED = 'FETCH_FAVORITE_ASSETS_FAILED';
export const ADD_FAVORITE_ASSET_SUCCEEDED = 'ADD_FAVORITE_ASSET_SUCCEEDED';
export const REMOVE_FAVORITE_ASSET_SUCCEEDED = 'REMOVE_FAVORITE_ASSET_SUCCEEDED';
// Actions
export const fetchFavorites = () => dispatch => {
  dispatch({
    type: FETCH_FAVORITE_ASSETS_PENDING
  });
  return fetchFavoriteAssets().then(response => {
    dispatch({
      type: FETCH_FAVORITE_ASSETS_SUCCEEDED,
      payload: response
    });
  }, error => {
    dispatch({
      type: FETCH_FAVORITE_ASSETS_FAILED,
      payload: error
    });
  });
};
// Reducers
const initialState = {
  status: UNINITIALIZED,
  favorites: []
};
export const favoriteAssetsReducer = (state = initialState, action) => {
  switch (action.type) {
    case FETCH_FAVORITE_ASSETS_PENDING:
      return Object.assign({}, state, {
        status: PENDING
      });
    case FETCH_FAVORITE_ASSETS_SUCCEEDED:
      return Object.assign({}, state, {
        status: SUCCEEDED,
        favorites: action.payload
      });
    case FETCH_FAVORITE_ASSETS_FAILED:
      return Object.assign({}, state, {
        status: FAILED
      });
    case ADD_FAVORITE_ASSET_SUCCEEDED:
      return Object.assign({}, state, {
        favorites: [...state.favorites, action.payload]
      });
    case REMOVE_FAVORITE_ASSET_SUCCEEDED:
      return Object.assign({}, state, {
        favorites: state.favorites.filter(favorite => favorite.objectId !== action.payload)
      });
    default:
      return state;
  }
};

// Selectors
export const selectFavoriteAssetsRoot = state => state[favoriteAssetsNamespace];
export const selectFavoriteAssets = createSelector(selectFavoriteAssetsRoot, favoriteAssetsRoot => favoriteAssetsRoot.favorites);
export const selectFavoriteReports = createSelector(selectFavoriteAssets, favoriteAssets => favoriteAssets.filter(favorite => favorite.objectType === 'REPORT'));
export const selectFavoriteDashboards = createSelector(selectFavoriteAssets, favoriteAssets => favoriteAssets.filter(favorite => favorite.objectType === 'DASHBOARD'));
export const selectFavoriteAssetsStatus = createSelector(selectFavoriteAssetsRoot, favoriteAssetsRoot => favoriteAssetsRoot.status);